// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--f4655";
export var annualEvents = "navigation-module--annual-events--ab31a";
export var annualNews = "navigation-module--annual-news--57d93";
export var annualProjects = "navigation-module--annual-projects--93211";
export var backgroundImage = "navigation-module--background-image--81fb6";
export var btnClose = "navigation-module--btn-close--48ae3";
export var btnOutlineLsuGold = "navigation-module--btn-outline-lsu-gold--e6439";
export var btnOutlineLsuPurple = "navigation-module--btn-outline-lsu-purple--daf2c";
export var btnPrimary = "navigation-module--btn-primary--d471d";
export var btnSecondary = "navigation-module--btn-secondary--48c6c";
export var dmaeIcon = "navigation-module--dmae-icon--eea17";
export var eventBlog = "navigation-module--event-blog--53610";
export var h1 = "navigation-module--h1--f2902";
export var h2 = "navigation-module--h2--20c3b";
export var h3 = "navigation-module--h3--01905";
export var h4 = "navigation-module--h4--c5ce3";
export var h5 = "navigation-module--h5--8c6ef";
export var h6 = "navigation-module--h6--5a48c";
export var hover = "navigation-module--hover--f1ef5";
export var menu = "navigation-module--menu--2922c";
export var navLink = "navigation-module--nav-link--dea8e";
export var navbarDark = "navigation-module--navbar-dark--c6154";
export var navbarNav = "navigation-module--navbar-nav--52e92";
export var navbarToggler = "navigation-module--navbar-toggler--b8fd2";
export var navbarTogglerIcon = "navigation-module--navbar-toggler-icon--17403";
export var newsArticle = "navigation-module--news-article--469b2";
export var newsEventsEvents = "navigation-module--news-events-events--c0a6f";
export var newsEventsNews = "navigation-module--news-events-news--3caf7";
export var pageItem = "navigation-module--page-item--5b85c";
export var pageLink = "navigation-module--page-link--1a6b9";
export var projectPost = "navigation-module--project-post--a4cb0";
export var textLight = "navigation-module--text-light--f6d71";
export var textLsuLightGold = "navigation-module--text-lsu-light-gold--88036";
export var textWhite = "navigation-module--text-white--d5a97";
export var topNavbar = "navigation-module--top-navbar--3a105";
export var topNavigation = "navigation-module--top-navigation--3fbfd";
export var underline = "navigation-module--underline--905db";